<template>
  <div class="upPic">
    <van-nav-bar :title="lang.up_title" />
    <div class="Introduction">
      <p>{{ lang.maximumPhotos1 }}{{ preview.length }}{{ lang.maximumPhotos2 }}</p>
      <p>{{ lang.maximumPhotos3 }}</p>
    </div>
    <!-- 图片上传 -->
    <div class="upPhoto">
      <ul>
        <draggable
          :list="preview"
          :options="{ disabled: preview.length == 0 ? true : false }"
          class="dargger"
          handle=".handle"
          @change="change"
        >
          <li
            v-for="(item, index) in 20"
            :key="index"
            :class="{ handle: preview[index] ? true : false }"
          >
            <van-uploader
              multiple
              :after-read="onRead"
              :max-size="20971520"
              class="upload"
              @oversize="fileBig"
            />
            <span
              v-if="preview[0] && preview[0].imagePath && index == 0"
              class="first"
            >{{ lang.first }}</span>
            <div
              v-if="preview.length && preview[index]"
              class="warp"
              @click="delShow(preview[index], index)"
            >
              <img
                :src="preview[index].imagePath | imgResize('user')"
                alt
                class="img"
              >
            </div>
            <svg
              v-if="!file[index]"
              class="icon camera"
              aria-hidden="true"
            >
              <use xlink:href="#icon-xiangji_x" />
            </svg>
            <van-loading
              v-if="file[index]"
              color="#1989fa"
              class="loading"
            />
          </li>
        </draggable>
        <van-actionsheet
          v-model="delshow"
          :actions="actions"
          :cancel-text="lang.cancel"
          :overlay="true"
          @select="delPic"
        />
      </ul>
    </div>
    <!-- 遮罩 ： 樓盤已成功刊登，妳現在可以關閉此頁面 -->
    <div :class="{ none: mask, shadow: true }" />
  </div>
</template>

<script>
import { Toast } from 'vant';
import { mapState, mapMutations } from 'vuex';
import draggable from 'vuedraggable';
import lang from './../../common/language/post';
export default {
  name: 'Post',
  data() {
    return {
      scoket: null,
      topTitle: '',
      lang: lang,
      delshow: false,
      actions: [{ name: lang.delPic }],
      delItem: {}, // 删除的对象
      uplist: [], // 正在上传中的数据
      upIng: [], //正在上传
      preview: [], // 接口返回的预览图
      file: [],
      delIndex: 0,
      identification: '',
      mask: true,
      delFile: {},
      lodingLength: 0,
    };
  },
  computed: {
    ...mapState(['propertyInfo']),
  },
  watch: {
    file: function (file) {
      this.lodingLength = this.file.length - this.preview.length;
      if (file.length > 20) {
        Toast(lang.picLength);
        this.file = file.slice(0, 20);
      }
      if (this.preview.length > 20) {
        this.preview = this.preview.slice(0, 20);
      }
    },
    preview: function (file) {
      this.lodingLength = this.file.length - this.preview.length;
    },
  },
  created() {
    // 引入图片上传插件
    let zipImg = document.createElement('script');
    zipImg.type = 'text/javascript';
    zipImg.src = 'https://static.house730.com/m/js/oss-upload.03.js';
    document.body.appendChild(zipImg);
    zipImg.onload = () => this.initZipImg();
    this.identification = this.$route.query.identification;
    if (this.$route.query && this.$route.query.token) {
      this.pub.setCookie('cEVaUDFrZ1kd0RA', this.$route.query.token);
    }
  },
  mounted() {
    document.oncontextmenu = function (e) {
      e.preventDefault();
    };
    let payScript = document.createElement('script');
    payScript.type = 'text/javascript';
    payScript.src = 'https://static.house730.com/m/js/signalr6.min.js';
    document.body.appendChild(payScript);
    payScript.onload = () => this.initScoket();
  },
  components: {
    [Toast.name]: Toast,
    draggable,
  },
  methods: {
    ...mapMutations(['setProperty', 'stepChange']),
    //初始化scoket连接
    initScoket() {
      const _this = this;
      // _this.scoket = new signalR.HubConnectionBuilder().withUrl(`http://10.4.18.194:8255/uploadhub?identification=${_this.identification}`).build();
      // sim请求地址 https://simrtc.house730.com/uploadhub
      // _this.scoket = new signalR.HubConnectionBuilder()
      //   .withUrl(`https://simrtc.house730.com/uploadhub?identification=${_this.identification}`)
      //   .withAutomaticReconnect({
      // uat消息请求地址 https://rtc.house730.com/uploadhub
      _this.scoket = new signalR.HubConnectionBuilder()
        .withUrl(`https://rtc.house730.com/uploadhub?identification=${_this.identification}`)
        .withAutomaticReconnect({
          nextRetryDelayInMilliseconds: (retryContext) => {
            if (retryContext.elapsedMilliseconds < 300000) {
              return 2000;
            } 
              return null;
            
          },
        })
        .build();
      _this.scoket.start().catch((err) => console.error(err.toString()));
      _this.scoket.on('ReceiveMessage', function (message) {
        /*code = 0 刊登完成 修改完成 复制完成  禁止用户操作当前页面*/
        if (JSON.parse(message).code == 0) {
          _this.mask = false;
          return;
        } 
          // file 文件 用来存储本地File 对象  loading 根据file文件判断
          // _this.pcImg   pc端传递过来的文件
          // _this.lodingLength  当前正在上传的图片数量
          // pcImg 大于本地  file 并且 wap有 正在上传
          let pcImg = JSON.parse(message);
          console.log('_this.lodingLength', _this.lodingLength);
          console.log('收到', JSON.parse(message));
          _this.file = pcImg;
          // pc端新增  && wap端正在上传
          if (_this.lodingLength && pcImg.length > _this.preview.length) {
            for (let k = 0; k < _this.lodingLength; k++) {
              _this.file.push({ imagePath: 1 });
            }
          }
          // pc端删除  && wap端正在上传
          else if (pcImg.length < _this.preview.length && _this.lodingLength) {
            for (let k = 0; k < _this.lodingLength; k++) {
              _this.file.push({ imagePath: 1 });
            }
            // pc端删除 || pc端上传
          } else if (pcImg.length == _this.preview.length && _this.lodingLength) {
            for (let k = 0; k < _this.lodingLength; k++) {
              _this.file.push({ imagePath: 1 });
            }
          }
          _this.preview = pcImg; /**vuex数据同步到当前组件数据*/
          _this.preview = _this.preview.filter((item) => item.imagePath != 1);
          _this.setProperty({ images: pcImg }); /**收到图片 存入vuex */
        

        // }
      });
      _this.scoket.on('Online', function (user) {
        if (_this.preview && _this.preview.length > 0) {
          _this.sendSocket(_this.preview);
        }
        console.log(user, '连接成功');
        console.log(_this.scoket);
      });
      // _this.scoket.send('hahaha', function() {
      //   /**hahaha  发送图片数组 */
      //   console.log('结果');
      // });
    },
    // scoket发送数据
    sendSocket(data) {
      console.log('跳转到这里传递_this.preview的值', data);
      const imagePath = [];
      data.forEach((item) => {
        const obj = { imagePath: item.imagePath, imageDesc: item.imageDesc || '', imageType: item.imageType || '0', imageID: item.imageID, propertyID: item.propertyID };
        imagePath.push(obj);
      });
      this.scoket
        .invoke('SendMessage', JSON.stringify(imagePath))
        .then(() => {
          console.log('发送数据 成功');
        })
        .catch(function (err) {
          console.log('发送数据 失败');
          return console.error(err.toString());
        });
    },
    // 图片切换顺序
    change() {
      // if (this.lodingLength > 0) { return } /*如果有正常上传的文件 禁止拖拽**/
      this.sendSocket(this.preview);
    },
    initZipImg() {
      this.$upload = new $upload({
        // 可选参数
        maxWidth: 1920, //最大压缩宽度(仅针对图片文件生效)
        maxHeight: 1920, //可选参数,最大压缩高度(仅针对图片文件生效)
        zipLimit: 3000, //压缩上传阈值，单位KB， 超过此大小则压缩，否则原图上传(仅针件图片文件生效)
        // 必选参数 OSS配置
        authorizationV4: true,
        region: 'oss-accelerate',
        accessKeyId: 'LTAI4FndXDCKXK4tEMRgRBBv',
        accessKeySecret: 'TKLkHAOMxiDNf1PjoGX7KguYmeqJgx',
        bucket: 'house730-files',
        // bucket: 'house730-uat-files'
      });
    },
    // 上传图片触发
    onRead(file) {
      // 上传单张
      if (file.constructor === Object) {
        file = [{ ...file }];
      }
      file.forEach((ele, index) => {
        if (!ele.file.name.toLocaleLowerCase().match(/(.*)\.(jpg|jpeg|png)$/)) {
          Toast(lang.fileError);
        } else {
          this.uplist.concat(this.uplist.push({ file: ele.file }));
        }
      });
      // 2. 图片上传
      this.file = this.file.concat(this.uplist);
      let data = new FormData();
      if (this.uplist.length > 20) {
        this.uplist = this.uplist.slice(0, 20);
      }
      if (this.file.length > 20) {
        this.uplist = this.uplist.slice(0, 20 - this.preview.length);
      }

      this.uplist.forEach((item) => {
        data.append('file', item.file);
      });
      if (this.uplist.length) {
        // oss上传图片
        let _this = this;
        this.uplist = []; // 清空file 对象
        const uploadPromises = file.map((item) => this.$upload.go(item.file));
        Promise.all(uploadPromises)
          .then((results) => {
            results.forEach((result, index) => {
              if (result.url) {
                const newUrl = result.url.replace('house730-files.oss-accelerate.aliyuncs.com', 'img.house730.com');
                _this.preview.push({ imagePath: newUrl, success: newUrl });
                _this.setProperty({ images: _this.preview });
                _this.lodingLength = _this.file.length - _this.preview.length;
                _this.sendSocket(_this.preview);
              } else {
                this.file.splice(index, 1); // 移除对应的文件
                Toast(lang.picfailure);
              }
            });
            // this.setProperty({ images: this.preview });
            // this.lodingLength = this.file.length - this.preview.length;
            // this.sendSocket(this.preview);
          })
          .catch((error) => {
            console.error('上传文件时出错:', error);
          });
      }
    },
    fileBig() {
      Toast(lang.fileBig);
    },
    delShow(item, index) {
      // if (this.lodingLength > 0) { return }  /*如果有正常上传的文件 禁止删除**/
      this.delshow = true;
      this.delItem = item;
      this.delIndex = index;
    },
    setDefault() {
      this.preview.forEach((item, idx) => {
        if (idx == 0) {
          item.isDefault = true;
        } else {
          item.isDefault = false;
        }
      });
    },
    delPic() {
      this.delshow = false; //关闭模态框
      this.preview.splice(this.delIndex, 1);
      this.file.splice(this.delIndex, 1);
      this.setProperty({ images: this.preview });
      this.sendSocket(this.preview);
    },
    savePic() {
      this.setDefault();
      this.setProperty({ images: this.preview });
      this.$router.go(-1);
    },
    // clearAll () {
    //   this.preview = []
    //   this.file = []
    //   this.propertyInfo.images = [];
    //   this.sendSocket([])
    // }
    // dragStart (e) {
    //   return false;
    // }
    // , dragover (event) {
    //   event.preventDefault()
    // }
  },
};
</script>

<style scoped lang="scss">
* {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.loading {
  font-size: 22px;
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
  z-index: 200;
}
.none {
  display: none;
}
.shadow {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 99999;
  background-color: #000;
  opacity: 0.6;
  color: #fff;
  font-size: 18px;
  // span {
  //   display: inline-block;
  //   margin-top: 70%;
  // }
}

img {
  pointer-events: none;
}
.upPic {
  overflow-x: hidden;
}
.van-nav-bar {
  border-bottom: 1px solid #e3e4e6;
  background-color: #fafbfc;
}
.van-nav-bar__title {
  font-size: 17px;
  font-weight: 600;
}
.van-nav-bar__text {
  color: #333;
}
.van-nav-bar .van-icon {
  font-size: 25px;
  color: black;
}
.upPic {
  height: 100%;
  background-color: #f5f6f7;
}
.Introduction {
  margin-top: 23px;
  margin-left: 16px;
  font-size: 14px;
  color: #999999;
  text-align: left;
  line-height: 20px;
}

.upPhoto {
  ul {
    width: 95%;
    margin: 16px auto;
    // .dargger {
    //   // display: flex;
    //   // justify-content: space-between;
    //   // flex-wrap: wrap;
    // }
    li {
      margin: 5px 5px 0 0;
      display: inline-block;
      width: 64px;
      height: 64px;
      background-color: #eeeeee;
      position: relative;
      .warp {
        width: 100%;
        height: 100%;
        display: inline-block;
        position: absolute;
        z-index: 1000;
        background: rgba(255, 255, 255, 0);
        top: 0;
        left: 0;
      }
      .first {
        //封面图icon
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1001;
        font-size: 12px;
        width: 35px;
        height: 17px;
        background-color: #666462;
        text-align: center;
        color: #fff;
        line-height: 17px;
      }
      .upload,
      .img {
        width: 100%;
        height: 100%;
      }
      /deep/ .van-uploader__input {
        z-index: 10;
      }
      .img {
        position: absolute;
        top: 0;
        left: 0;
      }
      .camera {
        font-size: 22px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }
}
</style>
